/**
 * PAT JSON Report API Functions
 * 
 * API functions for the new PAT JSON reporting system.
 * These integrate with the existing assignment interface.
 */

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api/";

// Check if an assignment is part of a PAT assessment
export const checkAssignmentPATStatus = (token, assignmentId) =>
  axios.get(`${API_URL}pat/assignments/${assignmentId}/check-status/`, {
    headers: { Authorization: `Token ${token}` }
  });

// Get PAT reports for a specific assignment
export const getPATReportsForAssignment = (token, assignmentId) =>
  axios.get(`${API_URL}pat/assignments/${assignmentId}/reports/`, {
    headers: { Authorization: `Token ${token}` }
  });

// Generate a single PAT report for a learner
export const generatePATReport = (token, data) =>
  axios.post(`${API_URL}pat/generate-report/`, data, {
    headers: { Authorization: `Token ${token}` }
  });

// Generate batch PAT reports for all learners
export const generateBatchPATReports = (token, data) =>
  axios.post(`${API_URL}pat/generate-batch-reports/`, data, {
    headers: { Authorization: `Token ${token}` }
  });

// Update an existing PAT report (creates new version)
export const updatePATReport = (token, data) =>
  axios.post(`${API_URL}pat/update-report/`, data, {
    headers: { Authorization: `Token ${token}` }
  });

// Helper function to determine if GitHub deployment should be used
export const shouldDeployToGitHub = () => {
  // You could add user preferences here
  return true; // Default to GitHub deployment
};

// Helper function to generate repository name
export const generateRepositoryName = (patAssessment) => {
  if (!patAssessment) return null;
  
  // Use existing repository naming pattern: 1058-2025
  const year = patAssessment.academic_year || new Date().getFullYear();
  
  return `1058-${year}`;
};